export const environment = {
    apiEndpoint: 'https://back.voting.apps.pwc.com.br/api/',

    envho: 'LOCAL|1.00',
    envhocolor: 'dev-color',
    production: true,
    // sign_out_url: 'https://fedsvc.pwc.com/ofis/public/SignOut.aspx',
    // sign_out_url: 'https://login.pwc.com/openam/XUI/?realm=/#loggedOut/',
    sign_out_url: 'https://login.pwc.com/openam/UI/Logout',

    idam: {
        authorization_endpoint: 'https://login.microsoftonline.com/513294a0-3e20-41b2-a970-6d30bf1546fa/oauth2/v2.0/authorize',
        app_url: 'https://voting.apps.pwc.com.br/',
        client_app_id: 'voting.apps.pwc.com.br'
    }
};
